import React, { useState } from 'react';
import './styles.scss';
import { PropTypes } from 'prop-types';
import Dropdown from 'react-bootstrap/Dropdown';
import CheckBox from '../../common/CheckBox';
import { noop } from '../propTypes';
import { DROPDOWN_VARIANTS } from '../constants';

const getDropDownItem = (item, variant) => {
    switch (variant) {
        case DROPDOWN_VARIANTS.CHECKBOX:
            return <CheckBox key={item.key} label={item.label} id={item.id} />;
        case DROPDOWN_VARIANTS.LIST_ICON:
            return (
                <div>
                    <i className={item.icon} />
                    <span>{item.label}</span>
                </div>
            );
        default:
            return <span>{item.label}</span>;
    }
};

function DropDown({ label, menuData, variant, onChange }) {
    // use State to update the dropdown label when the onSelect event is dispatched
    const [selected, setSelected] = useState(menuData[0].label);
    return (
        <Dropdown
            onSelect={(evt) => {
                const taxonomy = JSON.parse(evt);
                onChange(taxonomy.key);
                setSelected(taxonomy.label);
            }}
            className="custom-dropdown d-flex flex-row align-items-center"
        >
            <div className="label align-self-center d-flex flex-row">
                <span>{label}</span>
            </div>
            <div className="dropDown">
                <Dropdown.Toggle
                    className="btn dropdown-toggle dropdown-toggle-split"
                    variant={'none'}
                >
                    {selected}
                </Dropdown.Toggle>
            </div>
            <Dropdown.Menu className="dropdown-menu dropdown-menu-left">
                {menuData.map((item, index) => {
                    return (
                        <Dropdown.Item
                            key={index}
                            className="dropdown-item"
                            eventKey={JSON.stringify(item)} // react bootstrap currently unable to stringify object in onSelect value
                        >
                            {getDropDownItem(item, variant)}
                        </Dropdown.Item>
                    );
                })}
            </Dropdown.Menu>
        </Dropdown>
    );
}

DropDown.propTypes = {
    // label that will appear on dropdown
    label: PropTypes.string,
    // drop down data that will appear in menu
    menuData: PropTypes.arrayOf(PropTypes.object),
    // type of drop down items
    variant: PropTypes.string,
    // event handler for when a dropdown option is selected
    onChange: PropTypes.func,
};

DropDown.defaultProps = {
    // label that will appear on dropdown
    label: 'Period',
    // drop down data that will appear in menu
    menuData: [],
    // type of drop down items
    variant: 'checkbox',
    // default function passed as event handler when none is provided
    onChange: noop,
};

export default DropDown;
